import { createSelector } from 'reselect';
export var signatureSelector = function signatureSelector(state) {
  return state.signature;
};
export var groupsSelector = createSelector(signatureSelector, function (signature) {
  return signature.groups;
});
export default {
  signatureSelector: signatureSelector,
  groupsSelector: groupsSelector
};